import { Utils } from "@/plugins/utils";
import router from '@/router';
import moment from "moment";

export default {
	namespaced: true,
	state: {
		lstVde: [],
		vde: null,
		vd1pedido: "",
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		lstShip: [],
		lstShipConfirmed: [],
		lstVdf: [],
		lstVdz: [],
		vdkdoc: "",
		pendingSalesConfirmation: false
	},
	getters: {
		vdemodel(state){
			let vde = {...state.vde}
			if (vde.vdefecha){
				vde.vdefecha = Utils.ParseToDate(vde.vdefecha)
				vde.vdefecha = moment(vde.vdefecha).format("YYYY-MM-DDTHH:mm:ssZ");
			}else{
				vde.vdefecha = null
			}
			return {
				vde: vde,
				vd1pedido: state.vd1pedido,
				lstShip: state.lstShipConfirmed,
				vdkdoc: state.vdkdoc
			}
		},
		shipmentAmount(state){
			let amount = 0
			const reduceShipAmount = (accumulator, ship) => accumulator + ship.amount
			amount += state.lstShip.reduce(reduceShipAmount, amount)
			return amount
		},
		selectedAmount(state){
			let amount = 0
			const reduceShipAmount = (accumulator, ship) => accumulator + ship.amount
			amount += state.lstShipConfirmed.reduce(reduceShipAmount, amount)
			return amount
		}
	},
	mutations: {
		set(state, vde){
			state.vde = vde
			state.lstVdf = vde.lstVdf
			state.lstVdz = vde.lstVdz
		},
		initForm(state){
			state.lstVde = []
			state.vde = null
			state.vd1pedido = ""
			state.loading = false
			state.itemsPerPage = 20
			state.hasNext = false
			state.lstShip = []
			state.lstShipConfirmed = []
			state.lstVdf = []
			state.lstVdz = []
			state.vdkdoc = ""
		},
		setParamsDataTable(state, payload){
			state.lstVde = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		init(store, vde){
			store.state.vde = vde
			store.state.lstShip = []
			store.state.vd1pedido = ""
		},
		async get(store, vdedoc){
			return await this._vm.$axios.get(`/Consignment/SaleConfirmation/Find/${vdedoc}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
		},
		async find(store, vdedoc){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Localizando confirmação de venda", indeterminate: true }, {root: true})
			store.commit("initForm")
			await store.dispatch("get", vdedoc)
			.then(vde => {
				store.commit("set", vde)
			})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Gravando confirmação de venda", indeterminate: true }, {root: true})
			
			await this._vm.$axios.post("/Consignment/SaleConfirmation/Insert", store.getters.vdemodel )
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				
				store.state.vdkdoc = payload.vdkdoc

				if (payload.isError){
					throw new Error(payload.message)
				}
				
				store.dispatch("parameters/openDialog", {
					titleText: "Sucesso",
					titleColor: "green",
					text: "Confirmação de venda realizada com sucesso.<br/>Você será redirecionado para emissão de venda. Realize a venda dos itens acertados.",
					cancelAction: () => router.push({ path: "/oryxpdv/venda", query : { vdedoc: payload.vde.vdedoc}})
				}, { root: true })
				
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async search(store, { limit = 20, page = 1, orderBy = "DESC" }){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Consignment/SaleConfirmation/Search?search=${store.state.search}&limit=${limit}&page=${page}&orderBy=${orderBy}&pending=${store.state.pendingSalesConfirmation}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstVde = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		async delete(store, vdedoc){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluíndo confirmação de venda", indeterminate: true }, {root: true})
			await this._vm.$axios.delete(`/Consignment/SaleConfirmation/Delete/${vdedoc}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/confirmacoes-venda")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async findIsInvoice(store, vdedoc){
			return await this._vm.$axios.get(`/Consignment/SaleConfirmation/FindIsInvoice/${vdedoc}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return true
			});
		},
		async findVdeForReckoning(store, vdedoc){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Recuperando dados do acerto...", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.get(`/Consignment/SaleConfirmation/FindVdeForReckoning/${vdedoc}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async findPendingSalesConfirmation(store, cf1cliente){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Buscando dados do acerto de consignado...", indeterminate: true }, {root: true})
            let payload = await this._vm.$axios.get(`/Consignment/SaleConfirmation/FindPendingSalesConfirmation/${cf1cliente}`)
            .then(response => {
                return Utils.ValidateAxiosResponse(response.data);
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return []
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		}
	}
}